export default __webpack_public_path__ + "static/media/ratingFilled.4601e771.svg";